import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ValueService {
  private readonly subject = new Subject<any>();

  sendValue(value: boolean) {
    this.subject.next(value);
  }

  getValue(): Observable<any> {
    return this.subject.asObservable();
  }
}
